angular.module('zc')
  .component('zcSiteReportNavigation', {
    templateUrl: '/templates/projects.site_reports/navigation.html',
    bindings: { project: '<' },
    controller: zcSiteReportNavigationController,
  });

zcSiteReportNavigationController.$inject = ['$state', '$stateParams'];
function zcSiteReportNavigationController($state, $stateParams) {
  const vm = this;

  const FORMAT = 'YYYY-MM';
  const OLDEST_MONTH = moment('2018-05', FORMAT);
  const LATEST_MONTH = moment().startOf('month');
  const THIS_MONTH = moment($stateParams.month, FORMAT);
  const PREV_MONTH = moment($stateParams.month, FORMAT).subtract(1, 'month').format(FORMAT);
  const NEXT_MONTH = moment($stateParams.month, FORMAT).add(1, 'month').format(FORMAT);
  const CURRENT_STATE = $state.current.name;

  vm.thisMonth = $stateParams.month;
  vm.startAt = THIS_MONTH.toDate();
  vm.isOldest = isOldest;
  vm.isLatest = isLatest;
  vm.goBack = goBack;
  vm.goNext = goNext;

  function isOldest() {
    return THIS_MONTH.isSame(OLDEST_MONTH) || THIS_MONTH.isBefore(OLDEST_MONTH);
  }

  function isLatest() {
    return THIS_MONTH.isSame(LATEST_MONTH) || THIS_MONTH.isAfter(LATEST_MONTH);
  }

  function goBack() {
    if(isOldest()) return;
    $state.go(CURRENT_STATE, {
      projectId: vm.project.id,
      month: PREV_MONTH,
    });
  }

  function goNext() {
    if(isLatest()) return;
    $state.go(CURRENT_STATE, {
      projectId: vm.project.id,
      month: NEXT_MONTH,
    });
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.site_reports/navigation.controller.js